import { useForm, useFormState } from 'react-hook-form';
import { useFormCoordinatorContext } from './FormCoordinatorContext';

/**
 * Estrae lo stato di un campo di un form all'intenro di un form coordinato.
 */
export function useCoordinatedFormState(props: {
  name: string | undefined;
  formId: string;
}) {
  const { name, formId } = props;
  const coordinator = useFormCoordinatorContext();

  const formRef = coordinator.formRefs.current.get(formId)?.ref.current;

  // Se il control fosse null (e.g. non è ancora stato impostato come ref)
  // useFormState lancerebbe un eccezione facendo saltare tutto.
  const defaultControl = useForm().control;

  return useFormState({
    name: name,
    control: formRef?.control ?? defaultControl,
    disabled: !formRef?.control,
  });
}
